export const removeToken = () => {
    sessionStorage.removeItem('auth');
    return true;
};
